import React from 'react';
import styles from '../../styles';
import GridConfig from './GridConfig';
import { withStyles } from '@material-ui/core';
import AddEditHoliday from '../AddEditHoliday';
import { compose } from 'recompose';
import { withSnackbar } from 'notistack';
import DeleteHoliday from '../DeleteHoliday';
import HolidayDataGrid from './HolidayDataGrid';
import localStyles from './style';
import { withUserProfile } from '../../../../../userProfile/userProfileContext';
import { getDataWithQueryString } from '../../../../../api/componentAPIs';

class HolidayGrid extends React.Component {
  constructor(props) {
    super(props);
    this.gridConfig = new GridConfig({});
    this.state = {
      holidayList: null,
      showHolidayForm: false,
      userAccessibleTerminals: [],
      holidayDetails: null,
      selectedHolidayData: null,
      countryList: [],
      selectedHoliday: []
    };
  }

  componentDidMount() {
    this._isComponentMounted = true;
    this.fetchHolidays();
    this.getAllDropdownOption();
  }

  fetchHolidays = () => {
    if (!this._isComponentMounted) {
      return;
    }
    getDataWithQueryString('GetHolidaysAccessibleToTerminal').then(
      (response) => {
        if (response && response.status >= 200 && response.status < 400) {
          this.setState({
            holidayList: response.data
          });
          return;
        }
        this.handleHolidayFetchError();
      }
    );
  };

  handleHolidayFetchError = () => {
    this.setState({
      holidayList: []
    });
    this.props.enqueueSnackbar('Failed to fetch holidays', {
      variant: 'error'
    });
  };

  getAllDropdownOption = () => {
    const countryList = this.getOptions(
      this.props.userData.userProfile.terminals.map((terminal) => ({
        value: terminal.terminalCountry,
        label: terminal.terminalCountry
      }))
    );

    const userAccessibleTerminals = this.props.userData.userProfile.terminals.map((terminal) => ({
      value: terminal.terminalCode,
      label: terminal.terminalCode,
      country: terminal.terminalCountry,
      regionName: terminal.terminalRegion,
      terminalId: terminal.terminalId
    }));

    this.setState({
      userAccessibleTerminals,
      countryList
    });
  };

  getFilterOptions = (data) => {
    return data.map((option) => {
      return {
        value: option.value,
        text: option.value
      };
    });
  };

  getOptions = (data) => {
    return [...new Map(data.map((item) => [item['value'], item])).values()].filter((value) =>
      Boolean(value.value)
    );
  };

  openAddEditHolidayPanel = () => {
    this.setState({ showHolidayForm: true });
  };

  closeAddEditHolidayPanel = (selectedHoliday = []) => {
    this.setState({
      showHolidayForm: false,
      holidayDetails: null,
      selectedHoliday
    });
  };

  // Calls different operations to be done on selected holiday
  runCommand = (command, data) => {
    const holidayDetails = { ...data };
    switch (command) {
      case 'editHoliday':
        this.editHolidayInfo(holidayDetails);
        break;
      case 'deleteHoliday':
        this.setSelectedHolidayData(holidayDetails);
        break;
    }
    // Save selection to retain it for data refresh
    this.setState({
      selectedHoliday: [holidayDetails.holidayId]
    });
  };

  // Opens the edit holiday panel for updating holiday information
  editHolidayInfo = (holidayDetails) => {
    this.setState({
      holidayDetails,
      showHolidayForm: true
    });
  };

  setSelectedHolidayData = (selectedHolidayData) => {
    this.setState({
      selectedHolidayData,
    });
  };

  onCancelHolidayDeletion = () => {
    this.setState({
      selectedHolidayData: null
    });
  };

  onCloseHolidayDeletion = () => {
    this.closeAddEditHolidayPanel();
    this.fetchHolidays();
    this.onCancelHolidayDeletion();
  };

  render() {
    const { classes } = this.props;
    const {
      holidayDetails,
      userAccessibleTerminals,
      countryList,
      selectedHolidayData,
      showHolidayForm,
    } = this.state;
    return (
      <>
        <HolidayDataGrid
          gridData={this.state.holidayList}
          selectedRowData={this.state.selectedHoliday}
          gridConfig={this.gridConfig}
          userAccessibleTerminals={this.getFilterOptions(userAccessibleTerminals)}
          countryList={this.getFilterOptions(countryList)}
          openAddEditHolidayPanel={this.openAddEditHolidayPanel}
          showHolidayForm={showHolidayForm}
          runCommand={this.runCommand}
          classes={classes}
        />
        {showHolidayForm && (
          <AddEditHoliday
            open={showHolidayForm}
            onClose={this.closeAddEditHolidayPanel}
            holidayDetails={holidayDetails}
            userAccessibleTerminals={userAccessibleTerminals}
            countryList={countryList}
            fetchHolidays={this.fetchHolidays}
            drawerClasses={{
              paper: classes.holidayPaperAnchor
            }}
            variant="persistent"
            enqueueSnackbar={this.props.enqueueSnackbar}
            holidayList={this.state.holidayList}
            isCreateHolidayFlow = {!holidayDetails?.holidayId}
          />
        )}
        {selectedHolidayData && (
          <DeleteHoliday
            onCancel={this.onCancelHolidayDeletion}
            selectedHolidayData={selectedHolidayData}
            enqueueSnackbar={this.props.enqueueSnackbar}
            userAccessibleTerminals={userAccessibleTerminals}
            onCloseHolidayDeletion={this.onCloseHolidayDeletion}
          />
        )}
      </>
    );
  }
}

export default compose(
  withStyles((theme) => ({
    ...styles(theme),
    ...localStyles(theme)
  })),
  withSnackbar,
  withUserProfile,
)(HolidayGrid);
